<template>
  <div id="myDateShow">
    <div class="title">{{marketingMerchants.id?"修改":"新增"}} 商户资料</div>
    <div id="dataShow">
      <div class="line">
        <div class="key">商户类型</div>
        <div class="value">
          <el-select class="w500" v-model="marketingMerchants.marketingMerchantsType" placeholder="请选择商户类型">
            <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="line">
        <div class="key">商户名称</div>
        <div class="value">
          <el-input class="w500" v-model="marketingMerchants.marketingMerchantsName" placeholder="请填写商户名称"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">商户联系人</div>
        <div class="value">
          <el-input class="w500" v-model="marketingMerchants.marketingMerchantsOwner" placeholder="请填写商户联系人"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">联系地址</div>
        <div class="value">
          <el-input class="w500" v-model="marketingMerchants.marketingMerchantsAddress" placeholder=" 请填写联系地址"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">商户简介</div>
        <div class="value">
          <el-input type="textarea"
                    :autosize="{ minRows: 4 }"
                    class="w500" v-model="marketingMerchants.marketingMerchantsIntro"
                    placeholder="请填写商户简介（100-300字为佳）"></el-input>
        </div>
      </div>
      <div class="line">
        <div class="key">营业执照</div>
        <div class="value">
          <el-image v-if="marketingMerchants.marketingMerchantsLicense" :src="marketingMerchants.marketingMerchantsLicense" lazy></el-image>
        </div>
      </div>
      <div class="line">
        <div class="key"></div>
        <div class="value">
          <el-upload
                  :headers="headers"
                  ref="upload"
                  :on-change="upLoad"
                  :on-success="upLoadSeccess"
                  class="upload-demo"
                  name="multipartFile"
                  drag
                  :action="baseURL+'/marketingMerchants/upload'"
                  :auto-upload="false">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">重新提交执照</div>
          </el-upload>
        </div>
      </div>
      <div class="line">
        <div class="key"></div>
        <div class="value">
          <el-button type="primary" size="medium" @click="submit">提交信息</el-button>
        </div>
      </div>
      <div class="line"></div>
    </div>
    <div class="but">
      <el-button type="danger" size="small" @click="backClick">返回</el-button>
    </div>
  </div>
</template>

<script>
  import {getMarketingMerchantsById, newVue, updateMarketingMerchants} from "../../network/marketingMerchants";

  export default {
    name: "marketingMerchantsInsert",
    data(){
      return{
        marketingMerchants: {},
        marketingMerchantsId: '',
        options: [
          {
            value:"自营发起",
            label:"自营发起"
          },
          {
            value:"第三方联合商户",
            label:"第三方联合商户"
          }
        ],
        authorization:"",
        headers: {
        },
        baseURL:newVue.baseURL
      }
    },
    created() {
      newVue.obj = this;
      this.authorization=newVue.obj.common.loginInfo.jwtToken;
      this.headers.Authorization = this.authorization;
      this.common.HeaderLocationTwo.href =  "/marketingMerchants/list";
      this.common.HeaderLocationTwo.name = "营销商户列表管理"
      this.common.HeaderLocationThree.name = "新增or修改商户列表"
      if (this.$route.params.id!=null){
        this.marketingMerchantsId = this.$route.params.id;

        getMarketingMerchantsById(this.marketingMerchantsId).then(res => {
          this.marketingMerchants = res.data;
        })
      }


    },
    methods: {
      upLoadSeccess(res){
        this.marketingMerchants.marketingMerchantsLicense = res.data;
      },
      backClick(){
        this.$router.push("../list");
      },
      upLoad (file, fileList) {
        this.$refs.upload.submit()
      },
      submit(){
        updateMarketingMerchants(this.marketingMerchants).then(res => {
          console.log(res);
        })
      }
    }
  }
</script>

<style scoped>
  @import "../../assets/css/data.css";
  .w500{
    width: 500px;
  }
</style>
